/* DeSiM 公式店 — カートページの数量ステッパー ＋ 受け取り日セレクト。
   AJAX 不使用（brief 指示）: ±ボタンで number input の値を書き換え、フォームごと
   通常の POST で /cart へ送信する（japan-esim 参考実装と同じ方式）。
   本物の Shopify では /cart への POST が `updates[<line key>]` を読んで数量を
   更新する（main-cart.liquid の input name 参照）。 */
(function () {
  'use strict';
  var form = document.querySelector('[data-ds-cart]');
  if (!form) return;

  form.querySelectorAll('[data-ds-qty]').forEach(function (qty) {
    var input = qty.querySelector('.ds-qty__input');
    if (!input) return;
    qty.querySelectorAll('[data-ds-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-ds-qty-step'), 10) || 0;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        input.value = next;
        form.submit();
      });
    });
    input.addEventListener('change', function () {
      form.submit();
    });
  });

  /* fix round 1: 「QRコード受け取り日」セレクトに「今すぐ！」＋今日から14日分の
     予約日を追加する。

     日本時間（JST/Asia-Tokyo）の算出方法について: Intl.DateTimeFormat +
     timeZone: 'Asia/Tokyo' も使えるが、JST は夏時間を持たない**恒久的に
     UTC+9 固定**のタイムゾーンなので、UTC エポックに 9 時間を足してから
     UTC ゲッター（getUTCFullYear 等）で読む方が ICU データの有無やロケール
     サポートに依存せず、どの JS 実行環境（本地描画ハーネス含む）でも同じ結果に
     なる。この等価性は Asia/Tokyo に限って常に成立する（他のタイムゾーンでは
     夏時間があるので固定オフセット計算は使えない）。 */
  function jstPartsForOffsetDays(offsetDays) {
    var JST_OFFSET_MS = 9 * 60 * 60 * 1000;
    var DAY_MS = 24 * 60 * 60 * 1000;
    var d = new Date(Date.now() + JST_OFFSET_MS + offsetDays * DAY_MS);
    return {
      year: d.getUTCFullYear(),
      month: d.getUTCMonth() + 1,
      day: d.getUTCDate(),
      weekday: d.getUTCDay(), // 0=日 … 6=土
    };
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  var WEEKDAY_JA = ['日', '月', '火', '水', '木', '金', '土'];

  var pickupSelect = document.querySelector('[data-ds-pickup-select]');
  if (pickupSelect) {
    /* 最終全分岐レビュー Important 1（再水和欠落）の修正: main-cart.liquid が
       cart.attributes['QRコード受け取り日'] を data-ds-persisted-pickup に
       焼き込んでいる。ここでいったん読んでおいてから14日分の option を
       追加する — SSR は「今すぐ！」の1件しか option を持たないので、
       予約日が永続化されていても再レンダー直後は選択肢自体が存在せず、
       select は黙って "now" にフォールバックしてしまう（数量変更のたびに
       画面が実データを裏切って「今すぐ！」に巻き戻る）。 */
    var persisted = pickupSelect.getAttribute('data-ds-persisted-pickup') || '';
    var matchedPersisted = persisted === '' || persisted === 'now';

    for (var i = 1; i <= 14; i += 1) {
      var parts = jstPartsForOffsetDays(i);
      var option = document.createElement('option');
      /* CONTRACT（後続の発卡フルフィルメントタスクが依拠）:
         value="now" は今すぐ！、それ以外は "yyyy-mm-dd"（機械可読）。
         表示文字列（画面に見せる用）は「9/12（土）」のような日本語短縮表記。 */
      var value = parts.year + '-' + pad2(parts.month) + '-' + pad2(parts.day);
      option.value = value;
      option.textContent = parts.month + '/' + parts.day + '（' + WEEKDAY_JA[parts.weekday] + '）';
      if (persisted === value) {
        option.selected = true;
        matchedPersisted = true;
      }
      pickupSelect.appendChild(option);
    }

    /* 永続化された予約日が14日窓の外（例: 15日目以降を選んだ後に別セッションから
       戻ってきた等）だった場合、黙って "now" に落とすのではなく、その値専用の
       <option> を追加して選択する（実データを画面から消さない）。 */
    if (!matchedPersisted) {
      var extra = document.createElement('option');
      extra.value = persisted;
      extra.textContent = persisted;
      extra.selected = true;
      pickupSelect.appendChild(extra);
    }
  }

  /* nicety: 利用開始日（渡航日）の date input は今日より前を選べないようにする。 */
  var startDateInput = document.querySelector('[data-ds-start-date]');
  if (startDateInput) {
    var todayParts = jstPartsForOffsetDays(0);
    startDateInput.min =
      todayParts.year + '-' + pad2(todayParts.month) + '-' + pad2(todayParts.day);
  }
})();
